<template>
    <div>
        <div v-if="availableTariffs.length > 0">
            <h4>Tarifas</h4>
        </div>

        <div class="row">
            <div v-for="tariff in availableTariffs" :key="tariff.id" class="col-md-6 mb-1">
                <TextInput 
                    @input="(e) => handleInput(e, tariff)"
                    :value="getTariffQuantity(tariff)"
                    :label="tariff.type.name"
                    :name="`tariff-${tariff.type.name}`"
                    type="number"
                    min="0"
                    :disabled="false"
                    :required="true"
                    :error="tariffAmountIsUnavailable(findTariff(tariff))"
                    :helperText="tariffAmountIsUnavailable(findTariff(tariff)) ? 'Quantidade indisponível' : ''"
                />

                <small
                    v-if="helperText"
                    class="form-text"
                    v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
                >
                    {{ helperText }}
                </small>
            </div>
        </div>
    </div>
</template>

<script>

import TextInput from '../../../../TextInput';

export default {
    components: { TextInput },
    props: {
        appCode: String,
        value: {
            required: true,
        },
        product: {
            required: true,
        },
        scheduling: {
            required: true,
        },
        time: {
            required: true,
        },
        helperText: {
            type: String,
            required: false,
            default: ''
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
        };
    },
    computed: {
        isDateTimeSellingMode() {
            return this.product?.selling_mode === 'with_date_and_time';
        },
        isDateSellingMode() {
            return this.product?.selling_mode === 'with_date_only';
        },
        isWithoutDateSellingMode() {
            return this.product?.selling_mode === 'without_date';
        },
        defaultTariffGroup() {
            return this.product?.tariff_groups.find(group => group.is_default);
        },
        availableTariffs() {
            if (this.isWithoutDateSellingMode) {
                return this.defaultTariffGroup?.tariffs
            }

            return this.scheduling?.finalTariffGroup.tariffs ?? [];
        },
        selectedTariffAmountSum() {
            // retrieve the sum of the selected tariffs amount
            return this.value.reduce(
                (sum, tariff) => sum + tariff.amount,
                0
            );
        },
        isTariffSumAvailable() {
            if (this.isWithoutDateSellingMode) {
                return true
            }

            // time should be null in case the product selling mode is only date
            return this.isAmountAvailableOnDateTime(this.scheduling, this.time, this.selectedTariffAmountSum);
        },
    },
    methods: {
        findTariff(tariff) {
            return this.value.find(item => item.tariff.id === tariff.id)
        },
        getTariffQuantity(tariff) {
            return this.findTariff(tariff)?.amount || null
        },
        handleInput(value, tariff) {
            const newValue = [
                ...this.value
            ];

            const index = newValue.findIndex(item => item.tariff.id === tariff.id);

            // if there is a value for the tariff, edit the amount
            if (index !== -1) {
                const parsedValue = parseInt(value, 10);

                // if the value is 0 or empty string, remove the tariff from the array
                if (parsedValue === 0 || value === '') {
                    newValue.splice(index, 1);
                } else{
                    newValue[index].amount = parseInt(value, 10);
                }
            } else {
                // if the tariff was not selected, add it to the array
                newValue.push({
                    tariff,
                    amount: parseInt(value, 10)
                });
            }

            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },
        getSelectedTariffAmount(tariff){
            if (tariff.amount === '') return 0;
            return parseInt(tariff ?? 0, 10);
        },
        isAmountAvailableOnDateTime(sch, minutes, amount){
            const sq = sch.occupationRates.scheduleQuantities.find(sq => minutes == null || sq.minutes == minutes.value);
            return sq.occupation.availableAmount == null || sq.occupation.availableAmount === 0 || sq.occupation.availableAmount >= amount;
        },
        tariffAmountIsUnavailable(tariff) {
            if (this.isWithoutDateSellingMode) {
                return false
            }

            if (!tariff) return false

            if(!this.isTariffSumAvailable){
                return tariff.amount != 0;
            }

            // time should be null in case the product selling mode is only date
            // returning negated because is Unavailable
            return !this.isAmountAvailableOnTariff(tariff.tariff, this.time, tariff.amount);
        },
        isAmountAvailableOnTariff(tariff, minutes, amount) {
            const tsq = this.scheduling.occupationRates.tariffScheduleQuantities.find(tsq => tsq.tariffId == `${tariff.id}`);
            if (!tsq) {
                return false;
            }

            const sq = tsq.occupationSchedule.find(sq => minutes == null || sq.minutes == minutes.value);
            return sq.occupation.availableAmount == null || sq.occupation.availableAmount >= amount;
        },
        hasAnyUnavailableAmount() {
            return this.value.some(tariff => this.tariffAmountIsUnavailable(tariff));
        },
    }
}
</script>

<style scoped lang="scss">
</style>
